import classNames from 'classnames';
import { attempt, Button, Heading } from 'yoso';
import { Close } from '~/components/Icon/Close';
import { Modal, ModalProps } from '~/components/Modal/Modal';
import modalStyles from '../Modal.module.scss';
import bsStyles from './BottomSheet.module.scss';

export const styles = { ...modalStyles, ...bsStyles };
// export type BottomSheetProps = Omit<ModalProps, 'icon' | 'description'> & {
export type BottomSheetProps = Omit<ModalProps, 'icon'> & {
  size?: 'full';
};
export const BottomSheet = ({
  className,
  size,
  title,
  description,
  onDismiss,
  closeButton = (
    <Button
      className={classNames(bsStyles.closeButton, modalStyles.closeButton)}
      variant="transparent"
      onClick={onDismiss}
      aria-label="close">
      <Close />
    </Button>
  ),
  children,
  ...props
}: BottomSheetProps) => (
  <Modal
    className={classNames(styles.root, styles[size || ''], className)}
    confirmButton={null}
    dismissButton={null}
    closeButton={closeButton}
    onDismiss={onDismiss}
    {...props}>
    {(value) => (
      <>
        {title && (
          <Heading level={5} className={classNames(bsStyles.heading, modalStyles.heading)}>
            {title}
          </Heading>
        )}
        {description && (
          <p className={classNames(bsStyles.description, modalStyles.description)}>{description}</p>
        )}
        {attempt(children, value)}
      </>
    )}
  </Modal>
);
